import ConfirmPhoneForm from "./ConfirmPhoneFromsClass";
import Cart from "./CartClass";

export default class Checkout extends ConfirmPhoneForm{
    constructor() {
        super('.forms_group_checkout');

        this.totalData = {};
        this.rex = /(<([^>]+)>)/ig;

        this.changeRadioContent();
        this.bonusInput();
        this.geoLocation();
        this.editStep();
        this.calculateAll();
        this.buildData();
        //this.validFAfterSelect();

        this.step_1();
        this.step_2();
        this.step_2_auth();
        this.step_3();
        this.step_4();
    }

    /**
     * Step 1
     */
    formValidator($form) {
        let $this = this,
            $inF = $form.validate({
                highlight: function (element) {
                    $(element).parent().addClass("error").removeClass("valid");
                },
                unhighlight: function (element) {
                    $(element).parent().removeClass("error").addClass("valid");
                },
                submitHandler: function (form) {
                    //Check actions
                    let action = $(form).attr('action'),
                        dataTo = $(form).attr('data-to'),
                        formData = new FormData($(form)[0]);

                    $(form).find('button[type="submit"]').prop('disabled', true);

                    //Disable tabs
                    $('#row_first .tab_menu').addClass('disabled');
                    $('#row_first .tab_header').unbind('click.tabs.user');

                    $.ajax({
                        type: "POST",
                        url: action,
                        processData: false,
                        contentType: false,
                        dataType: "json",
                        data: formData
                    })
                        .then(function (resp) {
                            if (!resp.success) {
                                $this.showFormError($form, resp.message);
                                return;
                            }
                            $this.hideFormError($form);

                            //Send sms and show code form
                            if(resp.data['auth_step_1']) {
                                $(form).animate({opacity: 0}, 200, function() {
                                    //Hide from
                                    $(form).hide();

                                    //Enable tabs
                                    $('#row_first .tab_menu').removeClass('disabled');
                                    $this.step_1();

                                    //Initial sms timer
                                    if($(dataTo).attr('data-timer')) {
                                        $this.timerSendSms($(dataTo));

                                        $(dataTo).on('click', '.send_sms_again a', function (e) {
                                            e.preventDefault();
                                            if($(this).hasClass('active')) {
                                                $this.timerSendSms($(dataTo));
                                                if($(dataTo).attr('data-parent')) {
                                                    //TODO: need reset form?
                                                    $($(dataTo).attr('data-parent')).trigger('submit');
                                                }
                                            }
                                        });

                                        //Set phone number
                                        let phone = $(form).find('input[type="tel"]').val();
                                        $(dataTo).find('.header_info .number').html(phone);
                                        $(dataTo).find('input[name="phone_number"]').val(phone);
                                    }

                                    //Show next block
                                    $(dataTo).show();
                                    $(dataTo).animate({opacity: 1}, 200);
                                });
                            }

                            //Success auth|register
                            if(resp.data['auth_step_2']) {

                                //Disabled tab
                                $('#row_first .tab_menu').addClass('disabled');
                                $('#row_first .tab_header').unbind('click.tabs.user');


                                $this.totalData['id'] = resp.data.id;
                                $this.totalData['type_user'] = resp.data.type;

                                $this.totalData['first_name'] = resp.data.first_name;
                                $this.totalData['last_name'] = resp.data.last_name;
                                $this.totalData['phone'] = resp.data.phone;
                                $this.totalData['email'] = resp.data.email;

                                //Hide login content
                                $('#row_first .tab_content').slideUp(200);
                                $('#row_first .tab_header').addClass('disabled');

                                //Show form for user type
                                let from = $(form).closest('.checkout_wrap_row').attr('id'),
                                    to = $(form).closest('.checkout_wrap_row').attr('data-to');

                                //Hide login icon from header
                                $('a.header_menu-account').attr('style', 'display: none !important;');

                                $this.step_1_get_address();
                                $this.step_2_auth();
                                $this.changeStep(from, to);
                            }

                        })
                        .fail(function (xhr) {
                            $this.ajaxErrorForm($inF, xhr);

                            //Enable tabs
                            $('#row_first .tab_menu').removeClass('disabled');
                            $this.step_1();
                        })
                        .always(function () {
                            $(form).find('button[type="submit"]').prop('disabled', false);
                            $($this.formsGroup).find('> form .btn-area a.to_form').removeClass('disabled');
                        });
                }
            });

        this.initForms.push($inF);
    }
    step_1() {
        let self = this,
            $loginForms = $('#row_first form.form_first'),
            $smsForms = $('#row_first form.form_second');

        if($('input[name="type_user"]').val() === '2') {
            //Set def name if user auth
            self.totalData['first_name'] = $('input[name="auth_f_n"]').val();
            self.totalData['last_name'] = $('input[name="auth_s_n"]').val();
            self.totalData['phone'] = $('input[name="auth_p"]').val();
            self.totalData['email'] = $('input[name="auth_e"]').val();
        }

        $('#row_first .tab_header').bind('click.tabs.user', '.tab_menu:not(.disable)', function () {
            $smsForms.fadeOut();
            $loginForms.fadeIn().removeAttr('style');

            self.resetForm($loginForms);
            self.resetForm($smsForms);

            //Set user type
            setTimeout(function () {
                let $inputUser = $('#row_first input[name="type_user"]'),
                    idActiveUser = $('#row_first .tab_menu.active').attr('data-id');
                if(idActiveUser === '#ch_auth_tab_1') {
                    $inputUser.val(1);
                } else {
                    $inputUser.val(2);
                }
            }, 500);
        });
    }
    step_1_get_address() {
        //Users address
        let formData = new FormData();
        formData.append('type',  1);
        $.ajax({
            type: "POST",
            url: usersAddressUrl,
            processData: false,
            contentType: false,
            data: formData
        })
        .then(function (resp) {
            if(resp.success) {
                $('#point_delivery_old_user .address_d_select .drop_down-list li.empty').after(resp.data.html);
            }
        });

        //Users company
        formData = new FormData();
        formData.append('type',  2);
        $.ajax({
            type: "POST",
            url: usersAddressUrl,
            processData: false,
            contentType: false,
            data: formData
        })
            .then(function (resp) {
                if(resp.success) {
                    companyAddressArray = resp.data.json
                    $('#ch_pay_tab_2 .company_d_select .drop_down-list li.empty').after(resp.data.html);
                }
            });
    }


    /**
     * Step 2
     */
    step_2() {
        let self = this,
            $allForms = $('#row_second .tab_content form'),
            $pointDelFOld = $('#point_delivery_old_user');

        //Validate all forms
        $allForms.each(function () {
            $(this).validate({
                highlight: function (element) {
                    $(element).parent().addClass("error").removeClass("valid");
                },
                unhighlight: function (element) {
                    $(element).parent().removeClass("error").addClass("valid");
                },
                submitHandler: function (form) {

                    self.step_2_delivery_price();

                    //Get data
                    self.getData($(form));
                    self.calculateAll();
                    self.buildData();

                    let from = $(form).closest('.checkout_wrap_row').attr('id'),
                        to = $(form).closest('.checkout_wrap_row').attr('data-to');

                    self.changeStep(from, to);
                }
            });
        });

        //Add new address to old user
        $pointDelFOld.on('click', '.address_d_select .drop_down-list li', function () {
            if($(this).attr('data-value') === '0') {
                $pointDelFOld.find('.for_new_address').show();
            } else {
                $pointDelFOld.find('.for_new_address').hide();
            }
        });

        //Reset forms after change tabs
        $('#row_second .tab_header').bind('click', '.tab_menu:not(.disable)', function () {
            self.resetForm($allForms);

            //Remove active from select li
            $('#row_second .drop_down-list li.active').removeClass('active');
        });

        //Suggest NP
        let timeOut = '';
        $('.suggest_np').keyup(function () {
            let $this = $(this);
            clearTimeout(timeOut);
            timeOut = setTimeout(function () {
                let type = $this.attr('data-suggest'),
                    formData = new FormData();

                formData.append('type', type);
                formData.append('phrase', $this.val());
                if($this.attr('data-city-id')) {
                    formData.append('city_id', $this.attr('data-city-id'));
                }

                $.ajax({
                    type: "POST",
                    url: suggestNPUrl,
                    processData: false,
                    contentType: false,
                    data: formData
                })
                .then(function (resp) {
                    if(resp.success) {
                        $this.closest('.drop_down').find('.scrollbar-inner ul').html(resp.data.html);
                    }
                });
            }, 300);
        });

        //Select city & show warehouses
        $('.suggest_np[data-suggest="city"]').on('blur', function () {
            let $this = $(this);
            setTimeout(function () {
                let cityId = $this.siblings('input[name="id"]').val(),
                    $warehouse = $this.closest('.radio-content').find('.suggest_np[data-suggest="warehouse"]');

                if($this.val() !== '') {
                    $('input[name="city_ref"]').val($this.closest('.drop_down').find('.drop_down-list li.active').attr('data-ref'));

                    self.step_2_delivery_price();
                    $warehouse.attr('data-city-id', cityId);
                    $warehouse.prop('disabled', false);
                    $warehouse.parent().removeClass('disabled');
                } else {
                    $warehouse.attr('data-city-id', '');
                    $warehouse.prop('disabled', true);
                    $warehouse.parent().addClass('disabled');
                }
                //Reset warehouse
                $warehouse.val('');
                $warehouse.removeClass('full');
                $warehouse.parent().removeClass('valid');
                $warehouse.parent().siblings().find('li[data-value]').remove();
                $warehouse.parent().siblings().find('li.empty').removeAttr('style');

            }, 250);
        });
    }
    /**
     * Helpers for Step 2
     * Show different form for auth or new user
     */
    step_2_auth() {
        this.totalData['type_user'] = $('#row_first input[name="type_user"]').val();

        let $newUF = $('#address_delivery_new_user'),
            $oldUf = $('#point_delivery_old_user');
        if(this.totalData.type_user === '1') {
            $newUF.show();
            $oldUf.hide();
        } else {
            $newUF.hide();
            $oldUf.show();
        }
    }
    step_2_delivery_price() {
        if($('#row_second .tab_header li[data-id="#ch_del_tab_2"]').hasClass('active')) {

            let formData = new FormData();
            formData.append('city_ref', $('input[name="city_ref"]').val());
            formData.append('weight', Number($('input[name="total_weight"]').val()));
            formData.append('price', Number($('input[name="total_price"]').val()));
            formData.append('service_type', Number($('input[name="delivery_to_post"]:checked').val()));

            $.ajax({
                type: "POST",
                url: priceDeliveryNPUrl,
                processData: false,
                contentType: false,
                data: formData
            })
            .then(function (resp) {
                if(resp.success) {
                    $('#ch_del_tab_2 input[name="deliveryPrice"]').val( resp.data.result);
                    return true;
                }
                alert('Price delivery error');
            })
        }
    }

    /**
     * Step 3
     */
    step_3() {
        let self = this,
            $payFroms = $('#row_three form');

        $payFroms.each(function () {
            $(this).validate({
                highlight: function (element) {
                    $(element).parent().addClass("error").removeClass("valid");
                },
                unhighlight: function (element) {
                    $(element).parent().removeClass("error").addClass("valid");
                },
                submitHandler: function (form) {
                    //Get data
                    self.getData($(form));
                    self.calculateAll();
                    self.buildData();

                    let from = $(form).closest('.checkout_wrap_row').attr('id'),
                        to = $(form).closest('.checkout_wrap_row').attr('data-to');
                    self.changeStep(from, to);

                    //Check if user has email
                    if(self.totalData.email && self.totalData.email !== '') {
                        $('#row_final .row_final_form_email').hide();
                    }
                }
            });
        });

        //Reset forms after change radio
        $('#row_three .ch_content input[name="type_pay"]').bind('change', function () {
            self.resetForm($payFroms);
        });

        //Add new address to old user
        $('#row_three').on('click', '.company_d_select .drop_down-list li', function () {
            let $this = $(this),
                $wrapInputs = $this.closest('.radio-content');

            if($this.attr('data-value') === '0') {
                $('#row_three').find('.for_new_company').show();

                //Clear data
                $wrapInputs.find('input:not([name="company_choose"])').each(function () {
                    $(this).val('');
                    $(this).removeClass('full');
                });

            } else {
                $('#row_three').find('.for_new_company').hide();

                //Insert data
                let ID = $this.attr('data-value');
                if(companyAddressArray[ID]) {
                    let objectData = companyAddressArray[ID].value_array;
                    for (let property in objectData) {
                        if(objectData[property] !== '') {
                            $wrapInputs.find(`input[name="${property}"]`).val(objectData[property]).addClass('full');
                        } else {
                            $wrapInputs.find(`input[name="${property}"]`).val('').removeClass('full');
                        }
                    }
                }
            }

            //Always
            $('#row_three').find('.company_data_wrap').removeAttr('style');
        });
    }

    /**
     * Step 4
     */
    step_4() {
        let self = this,
            $final = $('#row_final');

        $final.find('.submit-order').on('click', function () {

            //Get email if empty
            let $emailForm = $final.find('.row_final_form_email');
            if(!self.totalData.email) {
                if($emailForm.valid()) {
                    $emailForm.find('.form-group').removeClass('error');
                    self.totalData['email'] = $emailForm.find('input[type="email"]').val();
                } else {
                    $emailForm.find('.form-group').addClass('error');
                    return false;
                }
            }

            let $this = $(this),
                formData = new FormData();

            $this.prop('disabled', true);

            formData.append('type_user', self.totalData.type_user);
            formData.append('fast', 0);
            formData.append('total_price', self.totalData.totalPrice);
            formData.append('save_price', self.totalData.totalSavePrice ? self.totalData.totalSavePrice : 0);
            formData.append('delivery_type', self.totalData.delivery_type);
            formData.append('delivery_price', self.totalData.totalDeliveryPrice);
            formData.append('delivery_post_type', self.totalData.delivery_to_post ? self.totalData.delivery_to_post : 0);
            formData.append('delivery_city', self.totalData.city ? self.totalData.city : '');
            formData.append('delivery_address', self.totalData.street ? self.totalData.street : '');
            formData.append('delivery_address_str', self.totalData.addressBuild);
            formData.append('delivery_address_id', self.totalData.address_delivery_id ? self.totalData.address_delivery_id : 0);
            formData.append('delivery_company_id', self.totalData.company_id ? self.totalData.company_id : 0);
            formData.append('delivery_company', self.totalData.company_choose ? self.totalData.company_choose : '');
            formData.append('delivery_company_create', self.totalData.company ? self.totalData.company : '');
            formData.append('payment_type', self.totalData.type_pay);
            formData.append('payer_type', self.totalData.payer_type);
            formData.append('message', self.totalData.message ? self.totalData.message : '');
            formData.append('city', self.totalData.city ? self.totalData.city : '');
            formData.append('house', self.totalData.house ? self.totalData.house : '');
            formData.append('flat', self.totalData.flat ? self.totalData.flat : '');
            formData.append('address', self.totalData.address ? self.totalData.address : '');
            formData.append('inn', self.totalData.inn ? self.totalData.inn : '');
            formData.append('ego', self.totalData.ego ? self.totalData.ego : '');
            formData.append('house_number', self.totalData.house_number ? self.totalData.house_number : '');
            formData.append('latitude', self.totalData.latitude ? self.totalData.latitude : 0);
            formData.append('longitude', self.totalData.longitude ? self.totalData.longitude : 0);
            formData.append('company_city', self.totalData.company_city ? self.totalData.company_city : '');
            formData.append('company_street', self.totalData.company_street ? self.totalData.company_street : '');
            formData.append('company_house', self.totalData.company_house ? self.totalData.company_house : '');
            formData.append('company_house_number', self.totalData.company_house_number ? self.totalData.company_house_number : '');
            formData.append('company_flat', self.totalData.company_flat ? self.totalData.company_flat : '');
            formData.append('post_index', self.totalData.post_index ? self.totalData.post_index : '');
            formData.append('email', self.totalData.email ? self.totalData.email : '');

            $.ajax({
                type: "POST",
                url: saveOrder,
                processData: false,
                contentType: false,
                data: formData
            })
            .then(function (resp) {
                if(resp.success) {
                    window.location.href = resp.data.redirect;
                    return true;
                }
                alert('Order error');
            })
            .fail(function (xhr) {
                alert('Order error.');
            })
            .always(function () {
                $this.prop('disabled', false);
            });
        });
    }

    //Other helpers functions
    /**
     * Calculate all price
     */
    calculateAll() {
        let $products = $('.item_product_small'),
            totalProductPrice = 0,
            totalProductOldPrice = 0,
            totalSavePrice = 0,
            totalDeliveryPrice = (this.totalData.deliveryPrice) ? Number(this.totalData.deliveryPrice) : 0,

            totalPrice = 0;

        $products.each(function () {
            let count = Number($(this).find('.count-product').attr('data-count'));

            //Find price and old price
            if($(this).find('span[data-price-now]').length) {
                totalProductPrice += parseFloat($(this).find('span[data-price-now]').attr('data-price-now')) * count;
            }
            if($(this).find('span[data-price-old]').length) {
                totalProductOldPrice += parseFloat($(this).find('span[data-price-old]').attr('data-price-old')) * count;
            } else if($(this).find('span[data-price-now]').length) {
                totalProductOldPrice += parseFloat($(this).find('span[data-price-now]').attr('data-price-now')) * count;
            }
        });

        //Calculate discount price
        if(totalProductOldPrice > totalProductPrice) {
            totalSavePrice = totalProductOldPrice - totalProductPrice;
        } else {
            totalSavePrice = 0;
        }

        //Calculate total
        totalPrice = totalProductPrice + totalDeliveryPrice;

        this.totalData['totalPriceOld'] = totalProductOldPrice;
        this.totalData['totalSavePrice'] = totalSavePrice;

        this.totalData['totalDeliveryPrice'] = totalDeliveryPrice;
        this.totalData['totalPrice'] = totalPrice;
    }

    /**
     * Show|hide content near radio button
     * TODO: if need global mov this method to Utils
     */
    changeRadioContent() {
        let $rb = $('.radio-button');
        if($rb.length) {
            $rb.on('change', 'input[type="radio"]', function () {
                $(this).closest('form').find('.radio-content').slideUp(200);
                $(this).closest('.radio-button').find('.radio-content').slideDown(200);
            });
        }
    }

    /**
     * Pay witch bonus
     */
    bonusInput() {
        let $bonusPay = $('.bonus_pay');
        if($bonusPay.length) {
            $bonusPay.on('change', 'input[type="checkbox"]', function () {
                let $this = $(this);
                if($this.prop('checked')) {
                    $this.closest('.bonus_pay').find('.form-group.input').slideDown(200, function () {
                        $this.closest('.bonus_pay').find('.form-group.input input').focus();
                    });
                } else {
                    $this.closest('.bonus_pay').find('.form-group.input').slideUp(200);
                }
            });
        }
    }

    /**
     * Go to next step
     * @param from
     * @param to
     */
    changeStep(from, to) {
        let $from = $('#' + from),
            $to = $(to);

        $from.find('.ch_l').addClass('ok').removeClass('edit');

        //Hide only content
        if(from === 'row_first') {
            $from.find('.tab_content').slideUp(200);
        } else {
            $from.find('.ch_content').slideUp(200);
        }

        $to.find('.ch_l').removeClass('disabled').addClass('edit').parent().addClass('edit_hide');
        $to.find('.ch_content').slideDown(200);
    }

    /**
     * Edit block
     */
    editStep() {
        let self = this;

        $('.checkout_tabs').on('click', '.checkout_wrap_row .ch_l:not(.disabled)', function (e) {
            e.preventDefault();
            let $this = $(this);

            if($this.hasClass('no_edit')) return false;

            if($this.siblings('.ch_content').css('display') !== 'none') return false;
            let $openBl = $('.checkout_wrap_row .ch_l.edit').siblings('.ch_content');

            if(self.validCloseBlock($openBl)) {
                //$('.checkout_wrap_row .ch_content:not(.no_hide)').slideUp(200, function () {
                $openBl.slideUp(200, function () {
                    //console.log($this.siblings('.ch_content').find('form input[name="type_pay"]'));
                    self.getData($(this).find('form'));
                    self.calculateAll();
                    self.buildData();
                });
                $this.siblings('.ch_content').slideDown(200, function () {
                    $('.checkout_content .checkout_wrap_row').removeClass('edit_hide');

                    $this.addClass('edit');
                    $openBl.siblings('.ch_l').removeClass('edit');

                    self.getData($this.siblings('.ch_content').find('form'));
                    //self.calculateAll();
                    //self.buildData();
                });
            }
        });
    }

    /**
     * Validate block`s forms before close
     * @param $element
     * @returns {boolean}
     */
    validCloseBlock($element) {
        let result = true;
        if($element.find('.tab_content').length) {
            $element.find('.tab_content .forms_group_ch').each(function () {
                if($(this).css('display') !== 'none') {
                    let $visibleForm = $(this).find('form');
                    $visibleForm.each(function () {
                        if($(this).css('display') !== 'none') {
                            if ($(this).valid()) {
                                result = true;
                                return false;
                            } else {
                                result = false;
                                return false;
                            }
                        }
                    });
                }
            });
        }
        return result;
    }

    /**
     * Reset validate & data from forms
     * @param $forms
     */
    resetForm($forms) {
        $forms.each(function () {
            $(this).validate().resetForm();
            $(this).find('input:not([readonly]):not([type="hidden"]):not([type="radio"]), textarea').val('');
            //$(this)[0].reset(); //reset radio
            $(this).find('.full:not(.no_reset_full)').removeClass('full');
        });
    }

    /**
     * Button for get user`s geo location
     */
    geoLocation() {
        let $geoBtn = $('.btn_share_location');
        if($geoBtn.length) {
            $geoBtn.on('click', function (e) {
                e.preventDefault();
                let self = $(this);
                if (!navigator.geolocation){
                    alert('Geolocation is not supported by your browser');
                    return;
                }
                navigator.geolocation.getCurrentPosition(function (position) {
                    let hrefGoogle = 'http://www.google.com/maps/place/'+ position.coords.latitude + ',' + position.coords.longitude;
                    self.siblings('.position').find('a')
                        .attr('href', hrefGoogle)
                        .html(position.coords.latitude + ', ' + position.coords.longitude);

                    self.siblings('.position').show();

                    self.find('input[name="latitude"]').val(position.coords.latitude);
                    self.find('input[name="longitude"]').val(position.coords.longitude);

                    //Hide form
                    self.closest('form').find(' > div:not(.btn_share_location_wrap):not(.btn-area)').attr('style', 'display: none !important');

                }, function (error) {
                    console.error(error);
                    self.siblings('.position').hide();
                });
            });
        }
    }

    /**
     * Set data to global variable
     * @param $form
     */
    getData($form) {
        let self = this;

        if($form.length === 1) {
            $.each($form.serializeArray(), function (i, value) {
                if(value.value !== "") {
                    self.totalData[value.name] = value.value.replace(self.rex , "");
                } else {
                    //delete self.totalData[value.name];
                }
            });
        } else {
            $form.each(function () {
                if ($(this).css('display') !== 'none' && $(this).parent().css('display') !== 'none') {
                    $.each($(this).serializeArray(), function (i, value) {
                        if(value.value !== "") {
                            self.totalData[value.name] = value.value.replace(self.rex , "");
                        } else {
                            delete self.totalData[value.name];
                        }
                    });
                }
            });
        }
    }

    /**
     * Validate form after select item from custom select
     */
    validFAfterSelect() {
        $('.drop_down .drop_down-list li:not(.empty):not(.active)').bind('click.custom.valid', function () {
            let $this = $(this);
            setTimeout(function () {
                $this.closest('form').valid()
            }, 200);
        });
    }

    /**
     * Build user`s info for step 4 & right panel
     */
    buildData() {
        let $checkoutP = $('.checkout--page');

        //price
        $checkoutP.find('.total-product').html(this.totalData.totalPriceOld.toLocaleString('ru-RU', {maximumFractionDigits: 2, minimumFractionDigits: 2}));
        if(this.totalData.totalSavePrice > 0) {
            $checkoutP.find('.total-save').html(this.totalData.totalSavePrice.toLocaleString('ru-RU', {maximumFractionDigits: 2, minimumFractionDigits: 2}));
            $checkoutP.find('.total-save').closest('.row_info').removeAttr('style');
        } else {
            $checkoutP.find('.total-save').closest('.row_info').hide();
        }
        $checkoutP.find('.total-total').html(this.totalData.totalPrice.toLocaleString('ru-RU', {maximumFractionDigits: 2, minimumFractionDigits: 2}));

        //delivery
        if(this.totalData.totalDeliveryPrice > 0) {
            $checkoutP.find('.total-delivery > i').html(this.totalData.totalDeliveryPrice);
            $checkoutP.find('.total-delivery').show();
            $checkoutP.find('.total-delivery-free').hide();
        } else {
            $checkoutP.find('.total-delivery').hide();
            $checkoutP.find('.total-delivery-free').show();
        }

        //delivery type
        // 1 - address delivery old
        // 2 - address delivery new
        // 3 - NP delivery
        // 4 - users delivery
        $checkoutP.find('.total-delivery-type').hide();
        $checkoutP.find('.total-delivery-type-' + this.totalData.delivery_type).removeAttr('style');
        let addressBuild = this.totalData.city;

        if(!this.totalData.city) {
            addressBuild = this.totalData.address_delivery;
        }
        if(this.totalData.street) {
            addressBuild += ', ' + this.totalData.street;
        }
        if(this.totalData.house) {
            addressBuild += ', ' + this.totalData.house;
        }
        if(this.totalData.flat) {
            addressBuild += ', кв. ' + this.totalData.flat;
        }

        addressBuild = addressBuild ? addressBuild : this.totalData.address;
        this.totalData['addressBuild'] = addressBuild;
        $checkoutP.find('.total-delivery-address').html(addressBuild);

        //pay type
        $checkoutP.find('.total-pay-type').hide();
        $checkoutP.find('.total-pay-type-' + this.totalData.type_pay).removeAttr('style');

        //User`s name, phone
        $checkoutP.find('.total-first-last-name').html(this.totalData.first_name + ' ' + this.totalData.last_name);
        $checkoutP.find('.total-phone').html(this.totalData.phone);

        //Companies
        if(this.totalData.payer_type === '2') {
            $checkoutP.find('.total-company-name').html(this.totalData.company);
            $checkoutP.find('.total-company-ego').html(this.totalData.ego);

            if(this.totalData.inn) {
                $checkoutP.find('.total-company-inn').html(this.totalData.inn);
                $checkoutP.find('.total-company-inn').parent().show();
            } else {
                $checkoutP.find('.total-company-inn').parent().hide();
            }

            let addressComp = this.totalData.company_city;

            if(this.totalData.post_index) {
                addressComp = this.totalData.post_index + ', ' + addressComp;
            }
            if(this.totalData.company_street) {
                addressComp += ', ' + this.totalData.company_street;
            }
            if(this.totalData.company_house) {
                addressComp += ', ' + this.totalData.company_house;
            }
            if(this.totalData.company_house_number) {
                addressComp += ', корп. ' + this.totalData.company_house_number;
            }
            if(this.totalData.company_flat) {
                addressComp += ', кв. ' + this.totalData.company_flat;
            }

            if(addressComp) {
                $checkoutP.find('.total-company-address').html(addressComp);
                $checkoutP.find('.total-company-address').parent().show();
            } else {
                $checkoutP.find('.total-company-address').parent().hide();
            }

            $checkoutP.find('.total_company_wrap').show();
        } else {
            $checkoutP.find('.total_company_wrap').hide();
        }
    }
}
